// Conectar una integracion (Microsoft, Notion) saca a la persona de la app: el navegador va al
// proveedor y vuelve con ?integration=<proveedor>_ok o _error, con ALM recargada de cero (pagina de
// inicio). Para devolverla a donde estaba, la pagina de origen se apunta antes de salir y se recoge
// al volver. Vive en sessionStorage: solo vale para esta pestana y se gasta al leerla.

const CLAVE = "alm.volverDeIntegracion";

// Apunta a que pagina volver (p. ej. "tareas") antes de ir al proveedor. Si el almacen no esta
// disponible (navegacion privada, bloqueado) no pasa nada: se vuelve a la pagina de inicio.
export function recordarVuelta(pagina, almacen = globalThis.sessionStorage) {
  try { almacen.setItem(CLAVE, String(pagina)); } catch { /* sin almacen: se vuelve a inicio */ }
}

// La pagina apuntada, SOLO si se vuelve de una integracion (el parametro de la URL) y se gasta.
// `proveedor` limita a quien la pidio ("microsoft", o una lista ["microsoft", "notion"] si lo piden varios):
// volver de otra integracion no cambia de pagina por una marca vieja de otra conexion.
export function tomarVuelta(parametro, proveedor, almacen = globalThis.sessionStorage) {
  let pagina = null;
  try { pagina = almacen.getItem(CLAVE); almacen.removeItem(CLAVE); } catch { return null; }
  if (!pagina) return null;
  const quienes = Array.isArray(proveedor) ? proveedor : [proveedor];
  return typeof parametro === "string" && quienes.some(p => parametro.startsWith(`${p}_`)) ? pagina : null;
}
